import React from 'react';
import {
    AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
} from 'recharts';
import {CHART_COLORS, CHART_INK, CHART_FONT} from './chartTheme';

type Point = Record<string, string | number>;

type Props = {
    data: Point[];
    xKey: string;
    yKey: string;
    color?: string;
    height?: number;
    valueFormatter?: (v: number) => string;
};

/** Single-series trend over time (revenue, message volume, active
 * collaborations, etc.) - one hue, filled area, recessive grid/axes per the
 * dataviz method: the data is the point, the chrome should recede. */
const TrendLineChart: React.FC<Props> = ({data, xKey, yKey, color = CHART_COLORS.teal, height = 220, valueFormatter}) => {
    if (!data || data.length === 0) {
        return <div className="text-muted small py-5 text-center">No data for this period yet.</div>;
    }

    return (
        <ResponsiveContainer width="100%" height={height}>
            <AreaChart data={data} margin={{top: 8, right: 8, left: 0, bottom: 0}}>
                <defs>
                    <linearGradient id={`trend-fill-${yKey}`} x1="0" y1="0" x2="0" y2="1">
                        <stop offset="5%" stopColor={color} stopOpacity={0.25}/>
                        <stop offset="95%" stopColor={color} stopOpacity={0}/>
                    </linearGradient>
                </defs>
                <CartesianGrid strokeDasharray="3 3" stroke={CHART_INK.grid} vertical={false}/>
                <XAxis
                    dataKey={xKey}
                    tick={{fill: CHART_INK.axis, fontSize: CHART_FONT.fontSize}}
                    axisLine={{stroke: CHART_INK.grid}}
                    tickLine={false}
                />
                <YAxis
                    tick={{fill: CHART_INK.axis, fontSize: CHART_FONT.fontSize}}
                    axisLine={false}
                    tickLine={false}
                    width={40}
                />
                <Tooltip
                    formatter={(value: number) => (valueFormatter ? valueFormatter(value) : value)}
                    contentStyle={{borderRadius: 10, border: '1px solid #f3f3f9', fontSize: 12}}
                />
                <Area type="monotone" dataKey={yKey} stroke={color} strokeWidth={2} fill={`url(#trend-fill-${yKey})`}/>
            </AreaChart>
        </ResponsiveContainer>
    );
};

export default TrendLineChart;
